import React from 'react';


const PersonalInfoForm = ({ 
  pipType, 
  firstName, 
  setFirstName, 
  middleName, 
  setMiddleName, 
  lastName, 
  setLastName, 
  pipResultOverview,
  setPipResultOverview,
  validationErrors, 
  setValidationErrors,
  viewMode = false,
  user,
  actions
}) => {
  const hasMiddleName = middleName && middleName.trim().length > 0;
  const shouldShowMiddleName = !viewMode || hasMiddleName;
  const hasOverview = pipResultOverview && pipResultOverview.trim().length > 0;
  const shouldShowOverview = !viewMode || hasOverview;

  return (
    <div className="step-form active">
      <div className="form-section">
        <div className="form-row">
          <div className="step-form-group">
            <label className="required">First Name</label>
            <input 
              placeholder="Enter first name" 
              value={firstName} 
              required 
              onChange={e => {
                setFirstName(e.target.value);
                if (validationErrors.firstName) {
                  setValidationErrors({ ...validationErrors, firstName: null });
                }
              }} 
              readOnly={viewMode}
            />
            {validationErrors.firstName && <span className="field-error">{validationErrors.firstName}</span>}
          </div>
          
          {shouldShowMiddleName && (
            <div className="step-form-group">
              <label>Middle Name</label>
              <input 
                placeholder="Enter middle name" 
                value={middleName} 
                onChange={e => setMiddleName(e.target.value)} 
                readOnly={viewMode}
              />
            </div>
          )}
        </div>

        <div className="form-row">
          <div className="step-form-group">
            <label className="required">Last Name</label>
            <input 
              placeholder="Enter last name" 
              value={lastName} 
              required 
              onChange={e => {
                setLastName(e.target.value);
                if (validationErrors.lastName) {
                  setValidationErrors({ ...validationErrors, lastName: null });
                }
              }} 
              readOnly={viewMode}
            />
            {validationErrors.lastName && <span className="field-error">{validationErrors.lastName}</span>}
          </div>
        </div>

        {shouldShowOverview && (
          <div className="form-row">
            <div className="step-form-group" style={{ width: '100%' }}>
              <label className={!viewMode ? 'required' : ''}>PIP Result Overview</label>
              {viewMode ? (
                hasOverview ? (
                  <textarea
                    value={pipResultOverview}
                    readOnly
                    rows={4}
                    style={{ resize: 'vertical' }}
                  />
                ) : (
                  <p style={{ fontStyle: 'italic', color: 'var(--text-muted)', marginTop: 6 }}>No overview provided.</p>
                )
              ) : (
                <textarea
                  placeholder="Summarize why this individual is considered a PIP"
                  value={pipResultOverview}
                  rows={4}
                  onChange={e => {
                    setPipResultOverview(e.target.value);
                    if (validationErrors.pipResultOverview) {
                      setValidationErrors({ ...validationErrors, pipResultOverview: null });
                    }
                  }}
                />
              )}
              {!viewMode && validationErrors.pipResultOverview && (
                <span className="field-error">{validationErrors.pipResultOverview}</span>
              )}
            </div>
          </div>
        )}
        {!viewMode && actions}
      </div>
    </div>
  );
};

export default PersonalInfoForm;